import React from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/src/ReactCrop.scss'

// import './App.css';

class ImageCrop extends React.Component {
    state = {
        src: null,
        // crop: {
        //     unit: '%',
        //     width: 30,
        //     aspect: 16 / 9,
        // },
        crop: {
            unit: 'px', // default, can be 'px' or '%'
            x: 130,
            y: 50,
            width: 200,
            height: 200
        }
    };

    onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            this.nomeArq = e.target.files[0].name;
            // const limiteMB = 0.8;
            // const maxSize = 1024 * 1024 * limiteMB; // 1.5MB = 1572864 bytes
            const limiteKB = 800;
            const maxSize = 1024 * 1024 * (limiteKB / 1000); // 1.5MB = 1572864 bytes
            if (e.target.files[0].size > maxSize) {
                // this.props.erroValidacaoImg(`O arquivo selecionado é muito grande. O tamanho máximo permitido é ${limiteKB}KB.`);
                this.props.erroValidacaoImg(`O arquivo selecionado é muito grande. Por gentileza, verifique a possibilidade de comprimir a imagem e otimizá-la para web.`);
                return;
            }

            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({ src: reader.result }, () => this.props.uploadArquivo())
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    // If you setState the crop in here you should return false.
    onImageLoaded = e => {
        this.imageRef = e.target;
        return false; // Return false to prevent setting crop state
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                // 'newFile.jpeg'
                this.nomeArq
            );
            this.setState({ croppedImageUrl }, () => this.props.getImg(this.state.crop, this.state.croppedImageUrl, this.imgAPI));
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                this.imgAPI = blob;
                blob.originalname = fileName;
                URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = URL.createObjectURL(blob);
                resolve(this.fileUrl);
            },
                'image/jpeg',  // Changed from 'image/jpg' to 'image/jpeg'
                0.75           // Added quality parameter (0.0 to 1.0)
            );
        });
    }

    render() {
        const { crop, croppedImageUrl, src } = this.state;

        return (
            <div className="row no-gutters">
                {/* <div key={`btn-arquivo`} className="col-6 col-lg-3 py-3 px-3"> */}
                <div key={`btn-arquivo`} className="col-12 text-left py-3 px-3">
                    <input type="file" accept=".jpg,.jpeg,.png" className="input-arquivo" onChange={this.onSelectFile} />
                </div>
                {src && (
                    <div className="offset-3 col-6 text-center py-2">
                        <p className="text-center my-0">Imagem original:</p>
                        <ReactCrop
                            crop={crop}
                            ruleOfThirds
                            // onImageLoaded={this.onImageLoaded}
                            onComplete={this.onCropComplete}
                            onChange={this.onCropChange}
                        >
                            <img src={src} alt=""
                                onLoad={this.onImageLoaded}

                            />
                        </ReactCrop>
                    </div>

                )}
                {croppedImageUrl && (
                    <div className="col-12 text-center py-2">
                        <p className="text-center my-0">Imagem final:</p>
                        <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
                    </div>
                )}
            </div>
        );
    }
}

export default ImageCrop